module.exports = __webpack_public_path__ + "img/purchase-volumes.eeebf661.png";